export default __webpack_public_path__ + "static/media/small-hydro-5-1-point-5.2dc2df81.jpg";